import {action} from "mobx";
import shiftSuggestionService from "../services/shiftSuggestionService";
import {b64DecodeToUrl} from "../utils/helpers";
import appStore from "./appStore";

class shiftSuggestionStore {
    @action getShiftSuggestionList = async params => {
        const resultOfRequest = await shiftSuggestionService.getShiftSuggestionList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action downloadShiftExcelFileFromSuggestions = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftSuggestionService.downloadShiftExcelFileFromSuggestions(
            params
        );
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action deleteShiftSuggestion = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftSuggestionService.deleteShiftSuggestion(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };

    @action approvePreference = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftSuggestionService.approvePreference(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };

    @action rejectPreference = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftSuggestionService.rejectPreference(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };

    @action revertPreference = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftSuggestionService.revertPreference(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };

    @action sendPreferenceNotification = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftSuggestionService.sendPreferenceNotification(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };
    @action getCouriersToChooseShifts = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftSuggestionService.getCouriersToChooseShifts(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };
    @action openPreferences = async params => {
        const resultOfRequest = await shiftSuggestionService.openPreferences(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };
    @action resolvePreferences = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftSuggestionService.resolvePreferences(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };
}

export default new shiftSuggestionStore();
